/**
 * @file
 * Интерфейс счётчиков скорости. Этот код должен быть помещён раньше элемента implementation.
 *
 * Код оптимизирован для минимального размера после uglify + gzip.
 */
(function(window, undefined$1) {
    window.Ya = window.Ya || {};

    /**
     * @typedef {number|string} BlockStatID – ключ из словаря https://stat.yandex-team.ru/DictionaryEditor/BlockStat
     */

    if (Ya.Rum) {
        throw new Error('Rum: interface is already defined');
    }

    var perf = window.performance;
    // eslint-disable-next-line no-implicit-coercion
    var navStart = (perf && perf.timing && perf.timing.navigationStart) || Ya.startPageLoad || +new Date();
    var requestAnimationFrame = window.requestAnimationFrame;

    var rum = Ya.Rum = {
        // флаг для проверки работоспособности счетчика
        // eslint-disable-next-line no-implicit-coercion
        enabled: !!perf,

        // Видимость документа в начале загрузки
        vsStart: document.visibilityState,

        // Менялась ли видимость документа document.visibilityState в процессе загрузки
        vsChanged: false,

        // список временных меток для дальнейшей отправки
        _defTimes: [],

        // список меток ресурсов для дальнейшей отправки
        _defRes: [],

        // список рассчитанных с помощью time()..timeEnd() дельт
        _deltaMarks: {},

        // список обработчиков, подписанных на срабатывание меток
        _markListeners: {},

        // функции которые необходимо вызвать при завершении работы
        _onComplete: [],

        // функции, которые необходимо вызвать при запуске
        _onInit: [],

        // функции для различных отписок при десктруктуризации рума
        _unsubscribers: [],

        /**
         * Настройки RUM
         *
         * @typedef {Object} RUMSettings
         */
        _settings: {},

        /**
         * Произвольные параметры, пробрасываемые в логи.
         *
         * @typedef {Object<BlockStatID, String|BlockStatID>} Vars – Объект с параметрами
         * @example
         * {
         *     "143": "28.1786",
         *     "1042": "Example%20User%20Agent%201.0"
         * }
         */
        _vars: {},

        /**
         * Инициализация интерфейса.
         *
         * @param {RUMSettings} settings – Настройки RUM
         * @param {Vars} vars
         */
        init: function(settings, vars) {
            rum._settings = settings;
            rum._vars = vars;
        },

        /**
         * Получить время от начала навигации.
         *
         * @returns {Number}
         */
        getTime: (perf && perf.now) ? function() { // eslint-disable-line no-nested-ternary
            return perf.now();
        } : Date.now ? function() {
            return Date.now() - navStart;
        } : function() {
            return new Date - navStart;
        },

        /**
         * Записывает время старта расчёта дельты.
         *
         * @param {String} counterId - Код BlockStat. ID метки времени
         */
        time: function(counterId) {
            rum._deltaMarks[counterId] = [rum.getTime()];
        },

        /**
         * Записывает время окончания расчёта дельты.
         * При загрузке RUM implementation записанные метрики будут отправлены на бэкэнд.
         *
         * @param {String} counterId - Код BlockStat. ID метки времени
         * @param {Object} [params=null] - Кастомные параметры дельты. Сюда же можно передать инстанс подстраницы
         */
        timeEnd: function(counterId, params) {
            var deltaMarks = rum._deltaMarks,
                deltaTimes = deltaMarks[counterId];

            if (!deltaTimes || deltaTimes.length === 0) {
                return;
            }

            deltaTimes.push(rum.getTime(), params);
        },

        /**
         * Отправить счетчик с временной меткой.
         *
         * @param {String} counterId  - Код BlockStat. ID метки времени
         * @param {Number} [time] - Время. Если не передано, вычисляется время
         *     от начала навигации до момента вызова функции
         * @param {Boolean} [addPerfMark=true] - Добавлять метку в User Timing или нет, true по умолчанию
         * @param {Object} [params=null] - Кастомные параметры счетчика. Сюда же можно передать инстанс подстраницы
         */
        sendTimeMark: function(counterId, time, addPerfMark, params) {
            if (time === undefined$1) {
                time = rum.getTime();
            }
            rum._defTimes.push([counterId, time, params]);
            rum.mark(counterId, time);
        },

        /**
         * Отправить счетчик с дельтой времени.
         *
         * @param {String} counterId - Код BlockStat. ID метки времени
         * @param {Number} [delta] - Точное значение дельты
         * @param {Object} [params=null] - Кастомные параметры дельты. Сюда же можно передать инстанс подстраницы
         * @param {Object} [opts=null] - настройки для метода, можно переопределить поведение по-умолчанию
         */
        sendDelta: function(counterId, delta, params, opts) {
            var deltaMarks = rum._deltaMarks;
            if (!deltaMarks[counterId] && typeof delta !== 'undefined') {
                var deltaEnd;
                // originalEndTime нужно, когда мы отправляем дельту отложенно (например при скрытии вкладки)
                if (opts && opts.originalEndTime) {
                    deltaEnd = opts.originalEndTime;
                } else {
                    deltaEnd = rum.getTime();
                }

                deltaMarks[counterId] = [deltaEnd - delta, deltaEnd, params];
            }
        },

        /**
         * Заглушка отправки временных меток ресурса,
         * откладывает отправку до загрузки основного кода.
         *
         * @param {String|Number} counterId
         * @param {String} url
         */
        sendResTiming: function(counterId, url) {
            rum._defRes.push([counterId, url]);
        },

        /**
         * Отправить тайминги requestAnimationFrame.
         *
         * @param {String|Number} position – blockStat-код позиции счётчика, например 85 – p0
         */
        sendRaf: function(position) {
            var forcePaintTimeSending = rum.getSetting('forcePaintTimeSending');

            if (!requestAnimationFrame || !forcePaintTimeSending && rum.isVisibilityChanged()) {
                return;
            }

            var prefix = '2616.' + position; // raf_metric.p0

            requestAnimationFrame(function() {
                if (!forcePaintTimeSending && rum.isVisibilityChanged()) {
                    return;
                }

                if (rum.getSetting('sendFirstRaf')) {
                    rum.sendTimeMark(prefix + '.205'); // raf_metric.p0.first
                }

                requestAnimationFrame(function() {
                    if (!forcePaintTimeSending && rum.isVisibilityChanged()) {
                        return;
                    }
                    rum.sendTimeMark(prefix + '.1928'); // raf_metric.p0.last
                });
            });
        },

        /**
         * Проверяет, изменялась ли видимость страницы при загрузке.
         *
         * @returns {Boolean}
         */
        isVisibilityChanged: function() {
            return rum.vsStart && (rum.vsStart !== 'visible' || rum.vsChanged);
        },

        /**
         * Поставить метку времени в User Timing https://www.w3.org/TR/user-timing/#dom-performance-mark
         * В браузерах, не поддерживающих window.performance.mark(), заменяется ничего не делающей заглушкой.
         *
         * @param {String} name - Код BlockStat. ID метки времени
         * @param {Number} [time] - Время. Опционально, нужно для сверки со временем, которое ставит
         *     само User Timing API, или для меток, которые ставятся "задним числом" (ttfb, ttfp etc.)
         */
        mark: perf && perf.mark ? function(name, time) {
            perf.mark(name + (time ? ': ' + time : ''));
        } : function() {
            // заглушка
        },

        /**
         * Получить значение настройки.
         *
         * @param {String} settingName
         * @returns {*|String}
         */
        getSetting: function(settingName) {
            var setting = rum._settings[settingName];

            return setting === null ? null : setting || '';
        },

        /**
         * Подписаться на срабатывание временной метки
         *
         * @param {String} counterId
         * @param {Function} cb
         */
        on: function(counterId, cb) {
            if (typeof cb !== 'function') return;

            (rum._markListeners[counterId] = rum._markListeners[counterId] || []).push(cb);

            return function() {
                /* Отписаться от срабатывания временной метки */
                if (rum._markListeners[counterId]) {
                    var index = rum._markListeners[counterId].indexOf(cb);
                    if (index > -1) {
                        rum._markListeners[counterId].splice(index, 1);
                    }
                }
            };
        },

        /**
         * Отправить данные о трафике
         */
        sendTrafficData: function() {},

        /**
         * Отправить текущее значение CLS и начать считать заново
         */
        finalizeLayoutShiftScore: function() {},

        /**
         * Отправить текущее значение LCP и начать искать заново
         */
        finalizeLargestContentfulPaint: function() {},

        /**
         * Получить дополнительные параметры, которые будут залогированы вместе с LCP
         */
        getLCPAdditionalParams: function() {}
    };

    // Отслеживаем изменения видимости вкладки
    function onVisibilityChange() {
        Ya.Rum.vsChanged = true;
        document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    if (document.addEventListener) {
        document.addEventListener('visibilitychange', onVisibilityChange);
    }
})(window);
